const ENV_JSON = '/env.json';

const getEnvVars = () => {
  if (process.env.NODE_ENV === 'development') {
    return new Promise(resolve => resolve(process.env));
  }

  return window.fetch(ENV_JSON).then(res => res.json());
};

export default getEnvVars;



// WEBPACK FOOTER //
// ./src/configEnv.js